import { TYPES_CONFIG } from '../../../constants';
export var createOptions = function createOptions(propertyType) {
  var operatorsConfig = TYPES_CONFIG[propertyType];

  if (operatorsConfig) {
    var operators = Object.keys(operatorsConfig);
    return operators.map(function (operatorKey) {
      return {
        label: operatorsConfig[operatorKey].label,
        rootOperator: operatorsConfig[operatorKey].rootOperator,
        value: operatorKey
      };
    });
  }

  return [];
};